<template>
  <page class="residencesView">
    <residences-table 
      v-loading="loading"
      :residences="residences" 
    />
  </page>
</template>

<script>
import ResidencesTable from '@/components/residences/ResidencesTable'
import { mapState } from 'vuex'

export default {
  name: "ResidencesView",
  components: {
    ResidencesTable
  },
  data: () => ({
    loading: false
  }),
  computed: {
    ...mapState({
      residences: state => state.residences.residences
    })
  },
  async mounted() {
    this.loading = true
    await this.$store.dispatch('residences/setResidences')
    this.loading = false
  }
}
</script>

<style lang="scss" scoped>
$c: '.residencesView';

#{$c} {
  & > p {
    margin-top: 0;
  }
}
</style>